import React from "react";
import { IProposedWorkItem } from "../../../types";
import { Image } from 'azure-devops-ui/Image';

export function WorkItemIcon(wi: IProposedWorkItem) {
    return (
      <div className='work-item-icon flex-column flex-center'>
        {wi.type == 'userstory' && (
          <Image alt='User Story' src={require('../../../img/user-story-icon.png')} />
        )}
        {wi.type == 'feature' && (
          <Image alt='Feature' src={require('../../../img/feature-icon.png')} />
        )}
      </div>
    );
  }
  